import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor' 

@Component({
    selector: 'app-json-editor',
    templateUrl: './json-editor-component.html',
    styleUrls: ['./json-editor-component.scss'],
    standalone: false
})
export class ScaiJsonEditorComponent implements OnInit, OnChanges {
  
    @Input() jsonData = {};
    @Input() jsonReadOnlyData = {};
    @Output() jsonSave = new EventEmitter<any>();
    @Output() jsonCancel = new EventEmitter<void>();    
    @ViewChild("editableJson") jsonEditorComponent: JsonEditorComponent | undefined;
    @ViewChild("reaOnlyJson") jsonReadOnlyComponent: JsonEditorComponent | undefined;
    changedData ={};
    jsonEditableOptions: JsonEditorOptions =  new JsonEditorOptions();
    jsonReadOnlyOptions: JsonEditorOptions = new JsonEditorOptions();

    @Input() readonlyPanelLabel: string = null;
    @Input() editablePanelLabel: string = null;

    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {    
      if (changes["jsonData"]) {
        this.changedData = changes["jsonData"].currentValue;
      }
    }
    
    ngOnInit(): void {    
      this.jsonEditableOptions.mode = 'code';
      this.jsonEditableOptions.enableSort = false;
      this.jsonEditableOptions.enableTransform = false;
      this.jsonEditableOptions.mainMenuBar = false;
      this.jsonEditableOptions.expandAll = true;

      this.jsonReadOnlyOptions.mode = 'view';
      this.jsonReadOnlyOptions.enableSort = false;
      this.jsonReadOnlyOptions.enableTransform = false;
      this.jsonReadOnlyOptions.mainMenuBar = false;
      this.jsonReadOnlyOptions.expandAll = true;
    }
    
    changeData(event: any) {
      if (event.type == 'change') {
        event.stopPropagation();
        return;
      }

      if (this.jsonEditorComponent != undefined && this.jsonEditorComponent.isValidJson()) {
        this.changedData = event; 
      } else {
        this.changedData = this.jsonData;
      }
    }
      
    saveJson() {
      try {
        this.jsonSave.emit(this.changedData);        
        this.jsonData = this.changedData;        
      } catch (e) {
          alert('Invalid JSON. Please correct it.');
      }
    }
    
    cancelJson() {
      this.jsonCancel.emit();
    }
}
